import apiClient from './api';

// 角色接口
export interface Role {
  id: string;
  name: string;
  code: string;
  description: string;
  permissions: string[];
  status: 'active' | 'inactive';
  createdAt: string;
  updatedAt: string;
}

// 角色列表响应
export interface RoleListResponse {
  list: Role[];
  total: number;
  page: number;
  pageSize: number;
}

// 创建角色请求
export interface CreateRoleRequest {
  name: string;
  code: string;
  description: string;
  permissions: string[];
}

// 更新角色请求
export interface UpdateRoleRequest {
  name: string;
  description: string;
  permissions: string[];
}

// 角色服务
export const roleService = {
  // 获取角色列表
  list: async (params?: {
    page?: number;
    pageSize?: number;
    status?: string;
    keyword?: string;
  }): Promise<RoleListResponse> => {
    const response = await apiClient.get<RoleListResponse>('/roles', { params });
    return response.data;
  },

  // 获取角色详情
  get: async (id: string): Promise<Role> => {
    const response = await apiClient.get<Role>(`/roles/${id}`);
    return response.data;
  },

  // 创建角色
  create: async (data: CreateRoleRequest): Promise<Role> => {
    const response = await apiClient.post<Role>('/roles', data);
    return response.data;
  },

  // 更新角色
  update: async (id: string, data: UpdateRoleRequest): Promise<Role> => {
    const response = await apiClient.put<Role>(`/roles/${id}`, data);
    return response.data;
  },

  // 删除角色
  delete: async (id: string): Promise<void> => {
    await apiClient.delete(`/roles/${id}`);
  },

  // 更新角色状态
  updateStatus: async (id: string, status: 'active' | 'inactive'): Promise<void> => {
    await apiClient.put(`/roles/${id}/status`, { status });
  },
};
